module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="' +
((__t = (id)) == null ? '' : __t) +
'" class="DescartesModal modal fade" role="dialog">\n    <div class="modal-dialog">\n        <!-- Modal content-->\n        <div class="modal-content">\n            <div class="modal-header">\n                <h4 class="DescartesModalTitle modal-title">' +
((__t = (title)) == null ? '' : __t) +
'</h4>\n                <button type="button" class="close" data-dismiss="modal">&times;</button>\n            </div>\n            <div class="modal-body">\n                <span class="DescartesUIText">' +
((__t = (message)) == null ? '' : __t) +
'</span>\n            </div>\n            <div class="modal-footer">\n                ';
 if (type === "remove") { ;
__p += '\n                <button type="button" class="DescartesUIButton btn ' +
((__t = (btnCss)) == null ? '' : __t) +
'" data-dismiss="modal">Annuler</button>\n                <button type="button" class="DescartesUIButtonSubmit btn ' +
((__t = (btnCssSubmit)) == null ? '' : __t) +
'" id="' +
((__t = (id)) == null ? '' : __t) +
'_remove">Supprimer</button>\n                ';
 } else { ;
__p += '\n                <button type="button" class="DescartesUIButton btn ' +
((__t = (btnCss)) == null ? '' : __t) +
'" data-dismiss="modal">Fermer</button>\n                ';
 } ;
__p += '\n            </div>\n        </div>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/ConfirmDialog.ejs
// module id = 392
// module chunks = 0